import React, { useEffect, useState } from "react";
import { doc, getDoc } from "firebase/firestore";
import { db } from "../firebase/config";

const defaultItems = [
  { title: "Music", image: "/selfcare/music.jpg", desc: "Listen to your favorite music. It\u2019s your soul\u2019s best friend." },
  { title: "Art", image: "/selfcare/art.jpg", desc: "Draw, paint or create. Being creative helps release stress and express feelings." },
  { title: "Yoga", image: "/selfcare/yoga.jpg", desc: "Free One\u2019s mind. Yoga creates balance and helps you feel calm and centered." },
  { title: "Gardening", image: "/selfcare/garden.jpg", desc: "Plant something and watch it grow. Gardening helps reduce stress and brings peace." },
  { title: "Physical Exercise", image: "/selfcare/physical.jpg", desc: "Move your body. Exercise supports mental health and improves energy, strength, and confidence." },
  { title: "Chats With Friends", image: "/selfcare/chat.jpg", desc: "Talk with friends and share your feelings. Connection helps reduce loneliness and stress." },
  { title: "Meditation", image: "/selfcare/meditation.jpg", desc: "Quiet the mind. Meditation improves focus, reduces stress, and supports inner calm." },
  { title: "Recommended Apps", image: "/selfcare/recomded.jpg", desc: "Try helpful apps for mindfulness, journaling, sleep, and mental wellness support." },
];                                  

const defaultContent = {
  heroTitle: "SELF CARE",
  breadcrumb: "Home / Self-Care",
  selfCareItems: defaultItems,
  ctaHeading: "The Random Acts of Kindness Foundation | Welcome",
  ctaButtonText: "Visit Now",
  ctaButtonUrl: "",
  subscribeHeading: "Get The Latest Updates",
  subscribePlaceholder: "Enter your email",
  subscribeButtonText: "Subscribe",
};

function SelfCareCard({ title, image, desc }) {
  return (
    <div className="grid grid-cols-[110px_1fr] md:grid-cols-[140px_1fr] gap-6 items-start">
      <div className="bg-gray-100 overflow-hidden shadow-sm">
        <img src={image} alt={title} className="w-full h-[110px] md:h-[140px] object-cover" />
      </div>
      <div className="pt-2">
        <h3 className="text-[14px] md:text-[16px] font-black uppercase tracking-widest text-black">{title}</h3>
        <p className="mt-3 text-[11px] md:text-[12px] text-[#555555] leading-[1.8] font-medium">{desc}</p>
      </div>
    </div>
  );
}

export default function Mentalhealthresources() {
  const [content, setContent] = useState(defaultContent);

  useEffect(() => {
    const fetch = async () => {
      try {
        const snap = await getDoc(doc(db, "settings", "selfCareContent"));
        if (snap.exists()) {
          const data = snap.data();
          setContent((prev) => ({
            ...prev,
            ...data,
            selfCareItems: data.selfCareItems || prev.selfCareItems,
          }));
        }
      } catch (e) {}
    };
    fetch();
  }, []);

  return (
    <div className="bg-white text-black min-h-screen" style={{ fontFamily: "'Montserrat', sans-serif" }}>
      {/* BREADCRUMB / HERO */}
      <section className="bg-[#f8dce8] py-8 md:py-12 border-b border-[#f0c8d8]">
        <div className="max-w-[1100px] mx-auto text-center px-4">
          <h1 className="text-[24px] md:text-[32px] font-black tracking-[0.3em] uppercase text-black">{content.heroTitle}</h1>
          <div className="mt-2 text-[10px] md:text-[11px] text-[#8b8b8b] uppercase tracking-widest">
            {content.breadcrumb}
          </div>
        </div>
      </section>

      {/* MAIN CONTENT */}
      <main className="max-w-[1100px] mx-auto px-6 py-12 md:py-20">
        {/* Self Care Items Grid */}
        <section className="grid md:grid-cols-2 gap-x-16 gap-y-16">
          {content.selfCareItems.map((item) => (
            <SelfCareCard key={item.title} {...item} />
          ))}
        </section>

        {/* Books Section - 3 images */}
        <section className="mt-24">
          <div className="grid grid-cols-3 gap-4 md:gap-10">
            {["/upload/au1.png", "/upload/au2.png", "/upload/au3.png"].map((src, idx) => (
              <div key={idx} className="shadow-lg hover:scale-105 transition-transform duration-300">
                <img src={src} alt={`book-${idx + 1}`} className="w-full h-[180px] md:h-[320px] object-cover rounded-sm" />
              </div>
            ))}
          </div>
        </section>

        {/* CTA Bar */}
        <section className="mt-24 bg-[#f8dce8] rounded-sm">
          <div className="flex flex-col md:flex-row items-center justify-between px-8 py-6 gap-4">
            <h2 className="text-[12px] md:text-[16px] font-black uppercase tracking-wider text-center md:text-left">{content.ctaHeading}</h2>
            <a href={content.ctaButtonUrl || "#"} target="_blank" rel="noopener noreferrer"
              className="bg-[#418ccf] hover:bg-[#357ab8] text-white text-[10px] md:text-[12px] font-bold uppercase px-8 py-3 tracking-widest transition-colors shadow-md inline-block">
              {content.ctaButtonText}
            </a>
          </div>
        </section>

        {/* Bottom Collage - 3 left + 1 right */}
        <section className="mt-12 grid lg:grid-cols-[1fr_400px] gap-10 items-start">
          <div className="space-y-10">
            {["/upload/kindness-top.jpg", "/selfcare/selfcare-banner.jpg", "/upload/selfcare-wheel.jpg"].map((src, i) => (
              <img key={i} src={src} alt={`collage-${i}`} className="w-full shadow-sm rounded-sm" />
            ))}
          </div>
          <div className="sticky top-10">
            <img src="/upload/au6.png" alt="50 mindful journaling topics" className="w-full shadow-md rounded-sm" />
          </div>
        </section>
      </main>

      {/* SUBSCRIBE SECTION */}
      <section className="bg-[#f4f4f4] border-t border-[#e8e8e8] py-12 md:py-16">
        <div className="max-w-[1100px] mx-auto px-6">
          <div className="flex flex-col md:flex-row items-center justify-center gap-8">
            <h3 className="text-[14px] md:text-[16px] font-black tracking-widest uppercase text-black">{content.subscribeHeading}</h3>
            <div className="flex w-full md:w-auto shadow-sm">
              <input type="email" placeholder={content.subscribePlaceholder}
                className="h-12 w-full md:w-[300px] border border-gray-300 bg-white px-5 text-[12px] outline-none focus:border-pink-300 transition-colors" />
              <button className="h-12 px-10 bg-black text-white text-[11px] font-bold uppercase tracking-widest hover:bg-gray-800 transition-colors">
                {content.subscribeButtonText}
              </button>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
